import React, { useState } from 'react'
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Button, Breadcrumb, Input } from 'semantic-ui-react'
import './index.scss'

import Ankit from '../../../assets/images/new-images/Ankit.jpg';
import Charmee from '../../../assets/images/new-images/Charmee.jpg';
import Amit from '../../../assets/images/new-images/Amit.jpeg';
import Vision from '../../../assets/images/new-images/vision.jpg';
import { NewInviteUser } from '../../common/newInviteUser';
import SEO from '../../../components/seo/SEO'
const AboutUs = () => {
  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'about', content: 'About Us', link: false },
  ]

  const MappesFaces = [
    {
      id: 1,
      name: 'Ankit Singhal',
      title: 'Co-founder & CEO',
      descr: 'Over 15  years of experience with B2B sales of high technology industrial products working with advanced technology companies, globally. Highly connected with many global industries behemonths and varied manufacturing industries supporting sales and marketing of emerging technologies',
      address: 'New Delhi, India',
      graduation: 'M.S in Electrical Engineering. USC',
      image: Ankit,
    },
    {
      id: 1,
      name: 'Charmee Patel',
      title: 'Co-founder & Data Scientist',
      descr: 'Well versed using large scale data and AI to drive results out of digital marketing, personalisation, customer analytics and digital transformation initiatives of largest brands in B2C world. Built and led data teams at multiple start-ups in early and late stage',
      address: 'Virginia, USA',
      graduation: 'M.S in Computer Science, USC , Data Science, University of Washington',
      image: Charmee,
    },
    {
      id: 1,
      name: 'Amit Bhatnagar',
      title: 'Co-founder & CTO',
      descr: 'Built successful SaaS products at multiple startups starting from seed stage to late stage. Well versed with software design, architecture, and development using cloud, serverless and modern technologies. Experience in building and scaling software teams of various sizes',
      address: 'Virginia, USA',
      graduation: 'M.S in Computer Science, USC',
      image: Amit,
    },
  ];

  return (
    <>
      <SEO key="new-aboutus-seo"
        robots="index, follow"
        canonicalUrl="/aboutus"
        alternateLink="/aboutus"
        pageType={'aboutus'}

      />
      <Header />
      <div className='aboutpage-view'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section className='banner-section'>
          <div className='mappes-container'>
            <div className='banner-card'>
              <div><SvgIcon className='banner-logo' name='mappes-logo' viewbox='0 0 136 16' /></div>
              <div><h2>Building Ecosystem Intelligence for Deep-Tech Companies.</h2></div>
              <p>At Mappes.io, we map global manufacturing value chain and ecosystems so companies can understand technologies, suppliers, applications, and markets — all in one structured intelligence platform.</p>
            </div>
            <div className='bannerrow-2'>
              <div className='banner-card2 col1'>
                <h3>Unifying Deep-Tech Value Chain</h3>
                <p>Established in 2017 and headquartered in the United States, Mappes was built to solve a critical challenge — industrial ecosystems were fragmented and lacked transparency. Companies struggled with limited visibility across technologies, stakeholders, and value chains.To address this, we created Mappes, an AI-driven ecosystem intelligence platform that maps complex high-tech industries such as Solar, Semiconductor, and Lithium-ion Batteries, enabling companies to discover opportunities, understand market landscapes, and build meaningful industrial connections.
                </p>
              </div>
              <div className='banner-card2 col2'>
                <h2>“Our vision at Mappes.io is to accelerate Deep-Tech manufacturing and enable faster market growth by bringing fragmented technology and ecosystem knowledge into one unified intelligence layer. By making discovery faster, networking seamless, and insights easily accessible, we help companies scale with confidence.”</h2>
              </div>
            </div>
          </div>
        </section>
        <section className='vision-section'>
          <div className='mappes-container'>
            <h2 className='main-heading text-left'><span>Our Vision:</span> Building the Intelligence Backbone of Modern Manufacturing</h2>
            <div className='vision-row'>
              <div className='vision-image-col'>
                <img src={Vision} alt='' />
              </div>
              <div className='vision-text-col'>
                <ul>
                  <li>
                    <div className='left-num'>1</div>
                    <div className='right-text'>Remove Barriers to Industrial Growth - Enable companies to easily discover technologies, partners, and opportunities by bringing clarity to complex global manufacturing ecosystems.</div>
                  </li>
                  <li>
                    <div className='left-num'>2</div>
                    <div className='right-text'>Accelerate Innovation Through Connected Intelligence - Help industries adopt new technologies faster, build stronger collaborations, and unlock hidden growth opportunities through structured and continuously evolving ecosystem knowledge.</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='customersuccess-section'>
          <div className='mappes-container'>
            <h2 className='main-heading text-left'>40 Years of Deep-Tech Industry Experience. Now Powering Ecosystem Intelligence.</h2>
            <ol>
              <li>
                <h3>Helping High-Tech Companies Navigate, Enter, and Grow in Complex Industrial Ecosystems</h3>
                <p>Expanding into new markets or adopting advanced technologies is rarely straightforward. Companies often struggle with fragmented industry knowledge, limited visibility into value chains, and difficulty identifying the right partners.
                  At Mappes.io, we help companies simplify this complexity by combining ecosystem intelligence, industry networks, and structured market visibility — enabling faster and more confident growth decisions.</p>
              </li>
              <li>
                <h3>Decades of Industrial Ecosystem Understanding</h3>
                <p>Our team brings deep experience across advanced manufacturing sectors including optical fiber, semiconductors, solar, and advanced materials. Over the years, we have worked closely with global technology companies and Indian manufacturers, gaining first-hand insight into how industrial ecosystems evolve, connect, and scale. This experience shapes how we help companies understand where they fit within complex global value chains and where their strongest opportunities exist.</p>
              </li>
              <li>
                <h3>From Fragmented Information to Structured Ecosystem Intelligence</h3>
                <p>Mappes brings together technologies, suppliers, applications, materials, and industry stakeholders into a connected intelligence platform. Companies gain visibility across entire manufacturing ecosystems — helping them identify innovation opportunities, understand market landscapes, and discover strategic partnerships.</p>
              </li>
              <li>
                <h3>Enabling Real Market Growth</h3>
                <p>Beyond intelligence, we help companies translate ecosystem visibility into actionable growth strategies. From identifying potential partners and customers to strengthening industry relationships, we enable companies to engage with the right stakeholders across markets with greater clarity and confidence.</p>
              </li>
              <li>
                <h3>Intelligence That Strengthens Over Time</h3>
                <p>Industrial knowledge often remains scattered across teams and individuals. Mappes helps organizations build a centralized and continuously evolving intelligence layer that preserves institutional knowledge, strengthens strategic decision-making, and compounds ecosystem understanding over time.</p>
              </li>
              <li>
                <h3>Who Mappes Supports</h3>
                <p>
                  <ul>
                    <li>Global technology companies expanding into new industrial markets</li>
                    <li>Manufacturers exploring new technologies and portfolio expansion opportunities</li>
                    <li>Product, strategy, and R&D teams evaluating emerging technology ecosystems</li>
                    <li>Business development and supply chain leaders building long-term industry partnerships</li>
                  </ul>
                </p>
              </li>
              <li>
                <h4>"Partnering with Mappes.io has been transformative for our global expansion strategy," says the company's Head of Global Expansion. "What would have taken us a year or more, Mappes accomplished in weeks. It's not just about the speed of market entry - it's about the quality of connections and the depth of market understanding we've gained."</h4>
              </li>
            </ol>
          </div>
        </section>
        <section className='facebehind-section'>
          <div className='mappes-container'>
            <h1 className='main-heading text-left'>The Faces behind <span>Mappes.io</span>!</h1>
            <div className='facebehind-row'>

              {MappesFaces.map((faces) => (
                <div className='facebehind-col'>
                  <div className='image-col'>
                    <img src={faces.image} alt='' />
                  </div>
                  <h4>{faces.name}</h4>
                  <label>{faces.title}</label> <br />
                  <label>{faces.address}</label>
                  <p>
                    {faces.descr}
                  </p>
                </div>
              ))}



            </div>
          </div>
        </section>
        <section className='mappessubcribe-section'>
          <div className='mappes-container'>
            <div className='mappessubcribe-card'>
              <div className='mappessubcribe-row'>
                <h2>Convert industrial complexity into strategic advantage with <span>Mappes.io</span></h2>
                <NewInviteUser />

              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default AboutUs